import { render, staticRenderFns } from "./cancelledList.vue?vue&type=template&id=52883974"
import script from "./cancelledList.vue?vue&type=script&lang=js"
export * from "./cancelledList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports